import Attachments from "../../components/home/attachments/attachments";
import Banner from "../../components/home/banner/Banner";
import BuildFleet from "../../components/home/buildFleet/buildFleet";
import BuildTuatara from "../../components/home/buildTuatara/buildTuatara";
import DealerLocator from "../../components/home/dealerLocator/dealerLocator";
import Journey from "../../components/home/journey/journey";
import ModelsInfo from "../../components/home/modelsInfo/modelsInfo";
import WarrantyCard from "../../components/home/warrantyCard/warrantyCard";

const Home = () => {
  return (
    <div className="bg-[#fff]">
      <Banner />
      <ModelsInfo />
      <div className="lg:my-[100px] my-[50px]">
        <div className="relative custom-container lg:h-[500px] md:h-[350px] h-[300px]">
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/4xLu2TscEew?si=hEWcAYaVCGfFS1bU"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        {/* <DealerLocator /> */}
      </div>
      <BuildTuatara />
      {/* <WarrantyCard /> */}
      <BuildFleet />
      {/* <Attachments /> */}

      <div className="bg-[#fff]">
        <div className="custom-container lg:pt-[90px] md:pt-[70px] sm:pt-[60px] pt-[50px] lg:pb-[90px] md:pb-[70px] sm:pb-[60px] pb-[50px]">
          <Journey title={"FIND A TUATARA FOR YOUR JOURNEY"} />
        </div>
      </div>
    </div>
  );
};
export default Home;
